module.exports = __webpack_public_path__ + "img/icon-nutrition.27cb9704.png";